export default __webpack_public_path__ + "static/media/webwine2.b6345b5c.png";